import { Modal, Form, Input, Divider } from "antd";

import Button from "antd-button-color";

import SocialAuth from "./SocialAuth";

const RegisterContainer = ({ visible, onClose, switchHandler }) => {
  return (
    <>
      <Modal
        centered
        title=" "
        zIndex="1030"
        footer={null}
        onOk={onClose}
        visible={visible}
        onCancel={onClose}
        maskClosable={false}
        className="modal-auth"
        closeIcon={<i className="far fa-times" />}
      >
        <h4 className="fs-20-s">
          Daftar
          <Button
            type="link"
            className="fs-12 float-end text-secondary pt-2 px-0"
            onClick={switchHandler}
          >
            Masuk
          </Button>
        </h4>

        <Form layout="vertical" name="register" className="mt-4">
          <Form.Item label="Username" className="mb-3">
            <Input name="email" type="email" placeholder="Username" />
          </Form.Item>
          <Form.Item label="Email" className="mb-3">
            <Input name="email" type="email" placeholder="Email" />
          </Form.Item>
          <Form.Item label="Password" className="mb-3">
            <Input.Password name="password" type="password" placeholder="Password" />
          </Form.Item>
          <Form.Item label="Konfirmasi Password">
            <Input.Password name="password" type="password" placeholder="Konfirmasi Password" />
          </Form.Item>
          <Form.Item className="mb-2">
            <Button type="dark" block>
              Daftar
            </Button>
          </Form.Item>

          <div className="mt-2 text-secondary mb-3">
            <span className="fs-12">
              Dengan mendaftar, saya menyetujui <a href="#/">Syarat dan Ketentuan</a> dan{" "}
              <a href="#/">Kebijakan Privasi</a>
            </span>
          </div>
        </Form>

        <Divider className="mb-4 mt-1" plain>
          <span className="text-muted">atau daftar dengan</span>
        </Divider>

        <SocialAuth text="Daftar dengan" />
      </Modal>
    </>
  );
};

export default RegisterContainer;
